import { render } from "./InscriptionsList.vue?vue&type=template&id=0d164f1a"
import script from "./InscriptionsList.vue?vue&type=script&lang=js"
export * from "./InscriptionsList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__